export default __webpack_public_path__ + "static/media/SponsorBannerMobile.196cedf0.png";